<template>
    <div id="residualNewReturn">
        <el-col>
            <div class="form-item-flex fl" style="width:50%;margin-top:-60px;margin-left:630px">
                <el-input @input="inputSerialComform"  clearable style="width:30%;margin-right:20px" v-model="returnForm.number" placeholder="请输入或扫描序列号"></el-input>
                <div style="width:20%">
                    <el-button type="primary" size="medium" @click="addSerialComformBtn" style="margin-bottom: 15px;">确认</el-button>
                </div>
                <div class="totalDiv" style="position:absolute;right:40px;top:60px;">
                    <small>数量：</small>
                    <strong >{{returnData.length}}</strong> &nbsp;&nbsp;&nbsp;&nbsp;
                    <span v-if="returnForm.returnType == 2">
                        <small >总计：</small>
                        <strong >{{totalMoney}}</strong> 元
                    </span>
                </div>
                <!-- <i class="el-icon-refresh" style="position: absolute;top:20px;right:20px;font-size: 25px;cursor: pointer;" @click="refresh()"></i> -->
            </div>
            <el-table
                :data="returnData"
                ref="multipleTable"
                border
                @selection-change="handleSelectionChange"
                @row-click="handleCurrentChange"
                :header-cell-style="{'text-align':'center'}"
                style="width: 100%">
                <el-table-column
                    align="center"
                    type="selection"
                    width="55">
                </el-table-column>
                <!-- <el-table-column
                    align="center"
                    type="index"
                    width="50"
                    label="序号">
                </el-table-column> -->
                <el-table-column
                    align="center"
                    prop="code"
                    width="100"
                    label="序列号">
                </el-table-column>
                <el-table-column
                    align="center"
                    width="200"
                    label="品牌品类型号">
                    <template slot-scope="scope">
                        {{scope.row.brandName}} {{scope.row.categoryName}} {{scope.row.modelName}}
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="materialName"
                    width="150"
                    label="物料名称">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="orderNo"
                    width="100"
                    label="关联订单号">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="warehouseType"
                    width="100"
                    label="仓库类型">
                    <template slot-scope="scope">
                        {{ scope.row.warehouseType | sysCodeFileter('warehouse_type') }}
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="maintainPrice"
                    width="100"
                    label="维修金额">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="materialName"
                    width="150"
                    label="领用时间">
                    <template slot-scope="scope">
                        <span v-if="scope.row.pickTime">{{scope.row.pickTime | date}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="engineerName"
                    width="100"
                    label="退料人">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="residualValue"
                    width="100"
                    label="残值">
                </el-table-column>
                <el-table-column
                    align="center"
                    label="操作">
                    <template slot-scope="scope">
                        <el-button @click.stop="deleteRow(scope.$index,scope.row, returnData)" type="text" size="small">移除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-button type="primary" class="fr" style="margin: 50px 20px 50px 0;" @click.native="DetermineSave()">提交</el-button>
            <el-button type="primary" class="fr" style="margin: 50px 20px 50px 0;" @click.native="DetermineSave1()">暂存</el-button>
            <el-button type="primary" class="fr" style="margin: 50px 20px 50px 0;" @click.native="deleteSerial">删除</el-button>
            <el-dropdown split-button type="primary" trigger="click" class="fr" style="margin: 50px 20px 50px 0;">
                {{pageStatus}}
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="closeSave()">离开当前页面</el-dropdown-item>
                    <!-- <el-dropdown-item @click.native="goOnSave()">留在当前页面</el-dropdown-item> -->
                </el-dropdown-menu>
            </el-dropdown>
            <el-button type="primary" class="fr" style="margin: 50px 20px 50px 0;" @click="cancelOrder()">取消新建</el-button>
        </el-col>
    </div>
</template>

<script>
  import {hideLoading, showLoading} from "../loading/loading";

    let moment = require("moment");
    import clip from '@/util/clipboard'
    import {
        wasteTreasureType,
        queryMaterialBySerialNumber,
        returnSaveAndUpdate,
        returnUpdateAndSubmit,
        returnMaterialDetails,
        returnRemoveEntry,
        returnMaterialDetailsList,
        returnMaterialRemove,
        selectParameterInfoBusiness
    } from "../../api/api";
    export default {
        name: 'residualNewReturn',
        props: {
            returnForm: {
               type: Object
            }
        },
        data () {
            return {
                totalMoney:0,//总金额
                pageStatus:'离开当前页面',
                labelPosition:'left',
                returnData: [],
                multipleSelection:[],
                isSubmit:false,
                searchForm:{
                    pId:'',
                    orderNo:'',
                    createUser:'',
                    belonger:'',
                    materialCode:'',
                    inventoryCode:'',
                    returnType:'',
                    residualType:'',
                    createTimeFrom:'',
                    createTimeTo:'',
                    isRetenRetain:''
                },
            }
        },
        created(){
            this.$destroy();
            this.isSubmit = false;
            if (!this.$route.query.orderId) {
                this.searchForm.pId = sessionStorage.getItem('saveOrderId');
            }else{
                let orderId = this.$route.query.orderId;
                this.searchForm.pId = orderId;
            }
            this.getReturnMaterialDetails();
            this.returnMaterialDetailsList();
        },
        methods: {
            //删除数据
            deleteSerial(){
                let para={
                    id: this.searchForm.pId
                };
                showLoading();
                returnMaterialRemove(para).then(res => {
                   hideLoading();
                    if (res.data.status==100) {
                        this.$message({
                            message: res.data.message,
                            type: "success"
                        });
                        this.backGo();
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            handleCurrentChange(row, event, column){
                let isHave = false;
                this.multipleSelection.forEach((item,index)=>{
                    if(row.code === item.code){
                        isHave = true
                    }
                })
                isHave ? this.$refs.multipleTable.toggleRowSelection(row,false) : this.$refs.multipleTable.toggleRowSelection(row,true);
            },
            //获取选中型号的物料数据 => 数组
            handleSelectionChange(val) {
                if(val != []){
                    this.multipleSelection = val;
                }
            },
            //获取退料暂存列表
            returnMaterialDetailsList(){
                this.searchForm.startRow = 1;
                this.searchForm.pageSize = 100;
                returnMaterialDetailsList(this.searchForm).then(res => {
                    if (res.data.status==100) {
                            this.returnData = res.data.results.list
                            this.returnData.forEach((item,index)=>{
                                item.createTime = this.filters.formatDate(item.createTime);
                                item.code = item.inventoryCode;
                                item.isRetenRetain = item.isRetenRetain ? Number(item.isRetenRetain) : item.isRetenRetain;
                            });
                            if(res.data.results.list.length > 0){
                                sessionStorage.setItem('saveOrderId', res.data.results.list[0].pid);
                            }
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //获取退料暂存表头列表
            getReturnMaterialDetails(){
                returnMaterialDetails({id:this.searchForm.pId}).then(res => {
                    if (res.data.status==100) {
                        this.returnForm.returnType = Number(res.data.results.returnType);
                        this.returnForm.id = res.data.results.id;
                        this.returnForm.residualType = res.data.results.residualType;
                        console.log(this.returnForm.residualType)
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            // //移除订单
            // deleteRow(index, rows) {
            //     if(rows.length > 0){
            //         if(this.returnForm.returnType == 2){
            //             this.totalMoney = Number(this.totalMoney) - Number(rows[index].amount)
            //         }
            //     }else{
            //         this.totalMoney = 0
            //     }
            //     rows.splice(index, 1);
            // },
            //移除
            deleteRow(index,row, rows) {
                if(!row.codeTotal){
                    let ids = [];
                    ids.push(row.id.toString());
                    let para={
                        parentId:this.returnForm.id,
                        ids:ids
                    };
                    showLoading();
                    returnRemoveEntry(para).then(res => {
                      hideLoading();
                      if (res.data.status==100) {
                            if(rows.length > 0){
                                if(this.returnForm.returnType == 2){
                                    this.totalMoney = this.totalMoney - Number(rows[index].amount)
                                }
                            }else{
                                this.totalMoney = 0
                            }
                            rows.splice(index, 1);
                        }else{
                            this.$message({
                                message: res.data.message,
                                type: "error"
                            });
                        }
                    }).catch((error) =>{
                        this.$Message.error(error.message);
                    })
                }else{
                    if(rows.length > 0){
                        if(this.returnForm.returnType == 2){
                            this.totalMoney = this.totalMoney - Number(rows[index].amount)
                        }
                    }else{
                        this.totalMoney = 0
                    }
                    rows.splice(index, 1);
                }
            },
            // 汇总数量和金额
            getAllMoney() {
                this.totalMoney = 0
                if (this.returnData) {
                    this.returnData.forEach(element => {
                        this.totalMoney = (Number(this.totalMoney) + Number(element.residualValue) * 1).toFixed(2)
                    })
                }
            },
            //查询序列号物料信息
            queryBySerialNumberData(){
                let isReplace = false
                if(this.returnForm.number.length == 8){
                    this.returnData.forEach((item,index)=>{
                        if(item.code == this.returnForm.number){
                            this.$message({
                                message: '当前序列号已添加至列表，请重新输入',
                                type: "warning"
                            });
                            isReplace = true
                        }
                    })
                    if(!isReplace){
                        let para = {
                            number:this.returnForm.number,
                            affiliationType:1,
                            queryType:1,
                            residualType:this.returnForm.residualType
                        }
                        queryMaterialBySerialNumber(para).then(res => {
                            if (res.data.status==100) {
                                if(res.data.results.length > 0){
                                    res.data.results[0].isRetenRetain = 0;
                                    let isHave = false;
                                    if(this.returnData.length > 0){
                                        this.returnData.forEach((item,index)=>{
                                            if(item.code == res.data.results[0].code){
                                                isHave = true
                                            }
                                        })
                                        if(!isHave){
                                            this.returnData.unshift(res.data.results[0])
                                        }
                                    }else{
                                        this.returnData.unshift(res.data.results[0])
                                    }
                                    this.getAllMoney();
                                }else{
                                    this.$message({
                                        message: '您输入的序列号有误，请重新输入',
                                        type: "warning"
                                    });
                                }
                                this.returnForm.number = "";
                            }else{
                                this.$message({
                                    message: res.data.message,
                                    type: "error"
                                });
                            }
                        }).catch((error) =>{
                            this.$Message.error(error.message);
                        })
                    }else {
                        this.returnForm.number = "";
                    }
                }
            },
            //提交添加序列号
            addSerialComformBtn(){
                if(!this.returnForm.returnType){
                    this.$message({
                        message: '请选择退料类型',
                        type: "warning"
                    });
                }else if(!this.returnForm.residualType){
                    this.$message({
                        message: '请选择残值类型',
                        type: "warning"
                    });
                }else if(this.returnForm.number.length == 0){
                    this.$message({
                        message: '您还未开始输入或扫描序列号',
                        type: "warning"
                    });
                }else{
                    this.queryBySerialNumberData();
                }
            },
            inputSerialComform(val){
                if(val.length == 8){
                    this.addSerialComformBtn();
                }
            },
            tabRemove (targetName) {
                // 首页不可删除
                if(targetName == '/') {
                    return;
                }
                //将该tab从options里移除
                this.$store.commit('delete_tabs', targetName);
                ////还同时需要处理一种情况当需要移除的页面为当前激活的页面时，将上一个tab页作为激活tab
                if (this.activeIndex === targetName) {
                    // 设置当前激活的路由
                    if (this.options && this.options.length >= 1) {
                        this.$store.commit('set_active_index', this.options[this.options.length-1].route);
                        this.$router.push({path: this.activeIndex});
                    } else {
                        this.$router.push({path: '/welcome'});
                    }
                }
            },
            //已提交
            DetermineSave(){
                console.log(this.returnForm)
                let isOk = true;
                if(!this.returnForm.returnType){
                    this.$message({
                        message: '请选择退料仓库',
                        type: "warning"
                    });
                    isOk = false;
                }
                if(this.returnForm.returnType == 2){
                    if(!this.returnForm.residualType){
                        this.$message({
                            message: '请选择残值类型',
                            type: "warning"
                        });
                        isOk = false;
                    }
                }
                if(this.returnData.length == 0){
                    this.$message({
                        message: '请扫码输入序列号添加物料',
                        type: "warning"
                    });
                    isOk = false;
                }
                if(this.multipleSelection.length == 0){
                    this.$message({
                        message: '请选择物料再提交',
                        type: "warning"
                    });
                    isOk = false;
                }
                if(isOk){
                    this.isSubmit = true;
                    let returnMaterialDetails = [];
                    this.multipleSelection.forEach((item,index)=>{
                        if(!item.pid){
                            returnMaterialDetails.push({
                                pid:this.returnForm.id,
                                materialCoding:item.materialCoding,
                                inventoryCode:item.code,
                                materialName:item.materialName,
                                modelId:item.modelId,
                                modelName:item.modelName,
                                belonger:item.engineerId,
                                pickTime:item.pickTime,
                                orderNo:item.orderNo,
                                inventoryState:item.inventoryState,
                                residualType:item.residualType,
                                residualValue:item.residualValue,
                                isRetenRetain:item.isRetenRetain,
                                warehouseType:item.warehouseType
                            })
                        }else{
                            returnMaterialDetails.push({
                                id:item.id,
                                pid:item.pid,
                                materialCoding:item.materialCoding,
                                inventoryCode:item.code,
                                isRetenRetain:item.isRetenRetain,
                                warehouseType:item.warehouseType
                            })
                        }
                    })
                    let para = {
                        returnMaterial:{
                            id:this.returnForm.id
                        },
                        entryList:returnMaterialDetails
                    };
                    showLoading();
                    returnUpdateAndSubmit(para).then(res => {
                      hideLoading();
                      if (res.data.status==100) {
                            this.$message({
                                message: '提交成功',
                                type: "success"
                            });
                            if (this.pageStatus == '留在当前页面') {
                                this.returnData = [];
                            }else{
                                this.tabRemove(this.$route.path)
                                this.$router.replace({
                                    path:'/returnMaterManageList'
                                })
                            }
                        }else{
                            this.$message({
                                message: res.data.message,
                                type: "error"
                            });
                        }
                        this.isSubmit = false;
                    }).catch((error) =>{
                        this.$Message.error(error.message);
                    })
                }
            },
            backGo(){
                this.tabRemove(this.$route.path)
                this.$router.replace({
                    path:'/returnMaterManageList'
                })
            },
            //暂存
            DetermineSave1(){
                console.log(this.returnForm)
                let isOk = true;
                if(!this.returnForm.returnType){
                    this.$message({
                        message: '请选择退料仓库',
                        type: "warning"
                    });
                    isOk = false;
                }
                if(this.returnForm.returnType == 2){
                    if(!this.returnForm.residualType){
                        this.$message({
                            message: '请选择残值类型',
                            type: "warning"
                        });
                        isOk = false;
                    }
                }
                if(this.returnData.length == 0){
                    this.$message({
                        message: '请扫码输入序列号添加物料',
                        type: "warning"
                    });
                    isOk = false;
                }
                if(this.multipleSelection.length == 0){
                    this.$message({
                        message: '请选择物料再提交',
                        type: "warning"
                    });
                    isOk = false;
                }
                if(isOk){
                    this.isSubmit = true;
                    let returnMaterialDetails = [];
                    this.multipleSelection.forEach((item,index)=>{
                        if(!item.pid){
                            returnMaterialDetails.push({
                                pid:this.returnForm.id,
                                materialCoding:item.materialCoding,
                                inventoryCode:item.code,
                                materialName:item.materialName,
                                modelId:item.modelId,
                                modelName:item.modelName,
                                belonger:item.engineerId,
                                pickTime:item.pickTime,
                                orderNo:item.orderNo,
                                inventoryState:item.inventoryState,
                                residualType:item.residualType,
                                residualValue:item.residualValue,
                                isRetenRetain:item.isRetenRetain,
                                warehouseType:item.warehouseType
                            })
                        }else{
                            returnMaterialDetails.push({
                                id:item.id,
                                pid:item.pid,
                                materialCoding:item.materialCoding,
                                inventoryCode:item.code,
                                isRetenRetain:item.isRetenRetain,
                                warehouseType:item.warehouseType
                            })
                        }
                    })
                    let para = {
                        returnMaterial:{
                            id:this.returnForm.id
                        },
                        entryList:returnMaterialDetails
                    };
                    showLoading();
                    returnSaveAndUpdate(para).then(res => {
                      hideLoading();
                      if (res.data.status==100) {
                            this.$message({
                                message: '提交成功',
                                type: "success"
                            });
                            if (this.pageStatus == '留在当前页面') {
                                this.returnData = [];
                            }else{
                                this.tabRemove(this.$route.path)
                                this.$router.replace({
                                    path:'/returnMaterManageList'
                                })
                            }
                        }else{
                            this.$message({
                                message: res.data.message,
                                type: "error"
                            });
                        }
                    }).catch((error) =>{
                        this.$Message.error(error.message);
                    })
                }
            },
            closeSave(){
                this.pageStatus = "离开当前页面"
            },
            goOnSave(){
                this.pageStatus = "留在当前页面"
            },
            //取消新建
            cancelOrder(){
                this.tabRemove(this.$route.path)
                this.$router.replace({
                    path:'/returnMaterManageList'
                })
            },
            refresh() {
                this.returnData = [];
                this.totalMoney = 0;
            }
        },
        computed: {
        },
        watch: {

        }
    }
</script>

<style type="text/css" lang="scss">
    #residualNewReturn{
        font-size: 14px;
        .form-item-flex{
            display:flex
        }
        .dialog-content{
            width:900px;
            margin:0 auto;
            .dialog-code-content{
                text-align: center;
                .el-col{
                    p{
                        border: 1px solid #e3e3e3;
                        line-height: 40px
                    }
                }
            }
        }
        .totalDiv{
            height: auto;
            overflow: hidden;
            text-align: right;
            font-size: 16px;
            background-color: #fff;
            border-bottom: 1px solid #e5e9f2;
            padding: 10px;
        }
    }
</style>



// WEBPACK FOOTER //
// residualNewReturn.vue?4faebaae